import { render, staticRenderFns } from "./ChartjsDoughnutChart3.vue?vue&type=template&id=3ebf767c&"
import script from "./ChartjsDoughnutChart3.vue?vue&type=script&lang=js&"
export * from "./ChartjsDoughnutChart3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports